import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import PropTypes from "prop-types";
import "./ScreenStepper.scss";

const PageLink = ({screen, head, body}) => {
    return (
        <li className="page-link">
            <div className={(screen + 1 < body) ? "rectangle-gray" : "rectangle-blue"}></div>
            <button className={(screen + 1 >= body) ? "circle-blue" : "circle-black"} disabled>
                <button className={(screen + 1 === body) ? "dot-blue" : "tick-blue"} disabled></button>
            </button>
            <div className="text">
                <h4 className="head-text">{head}</h4>
                <h5 className="body-text">Step {body}</h5>
            </div>
        </li>
    );
}

PageLink.propTypes = {
    screen: PropTypes.number.isRequired,
    head: PropTypes.string.isRequired,
    body: PropTypes.number.isRequired,
}

const ScreenStepper = ({initialScreen, heading, children, onNext, onPrevious, onSkip, hideSkip, hidePrevious, hideSteps, onHide}) => {
    const [screen, setScreen] = useState(initialScreen? initialScreen : 0);
    const [isPending, setIsPending] = useState(false);
    const numOfScreens = children.length? children.length : 1;
    const currentScreen = numOfScreens === 1? children : children[screen];
    const canGoBack = screen > 0;
    const isLastScreen  = screen === numOfScreens-1;
    const enablePrevButton = (canGoBack &&isLastScreen);

    const onNextHandler = async () => {
        setIsPending(true);
        const result = await onNext({currentScreen: screen});
        setIsPending(false);
        if (result === true && screen < numOfScreens - 1) {
            setScreen(screen + 1);
        }
    };

    const onPreviousHandler = async () => {
        await onPrevious({currentScreen: screen});
        if (screen > 0) {
            setScreen(screen - 1);
        }
    };

    const onSkipHandler = async () => {
        await onSkip({currentScreen: screen});
        if (screen < numOfScreens - 1) {
            setScreen(screen + 1);
        }
    };

    return (
        <Modal show={true} contentClassName="modal-styles" className="screen-stepper" onHide={onHide}>
            <Modal.Header>
                <h4 className="panel-title">
                    {heading}
                </h4>
            </Modal.Header>
            <Modal.Body>
                <Container className="modal-body-container">
                    <Row className="modal-body-container-row">
                        { !hideSteps &&
                            <Col className="side-panel" xs="auto" style={{ margin: "0px", padding: "0px"}}>
                                <ul className="screens-list">
                                    {
                                        children.map((element, index) => (
                                            <PageLink head={element?.props?.stepperLabel} key={index} body={index + 1} screen={screen} />
                                        ))
                                    }
                                </ul>
                            </Col>
                        }
                        <Col>
                            {currentScreen}
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                {
                   !hideSkip &&
                   <Button className={`skip-button ${children[screen].props?.canSkip? "enabled" : "disabled"}`}
                        disabled={!children[screen].props.canSkip} onClick={onSkipHandler}>
                        Skip
                    </Button>
                }
                {
                    !hidePrevious &&
                    <Button className= {`previous-button ${enablePrevButton ? "enabled" : "disabled"}`} onClick={onPreviousHandler} disabled={!canGoBack}>
                        Previous
                    </Button>
                }
                <Button className="next-button" type="submit" onClick={onNextHandler} disabled={isPending}>
                    {isPending && <Spinner className="nextButtonSpinner" as="span" animation="border" size="sm" role="status" />}
                    {isLastScreen ? "Finish setup" : "Next"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ScreenStepper.propTypes = {
    initialScreen: PropTypes.number,
    heading: PropTypes.string.isRequired,
    children: PropTypes.array.isRequired,
    onNext: PropTypes.func.isRequired,
    onPrevious: PropTypes.func,
    hideSkip: PropTypes.bool,
    hidePrevious: PropTypes.bool,
    hideSteps: PropTypes.bool
}

export default ScreenStepper;